import type { JSX } from "react";
import { spacing } from "../../stitches.config";
import { HorizontalScrollBar } from "./HorizontalScrollBar/HorizontalScrollBar";
import TabItem from "./TabItem";

export default <T extends string>({
  currentTab,
  setTab,
  tabs,
  color = "blue",
  activeTabStyle = "underline",
}: {
  currentTab: T;
  setTab: (value: T) => void;
  tabs: Array<{ label: string | JSX.Element; value: T }>;
  color?: "blue" | "grey";
  activeTabStyle?: "underline" | "outline";
}) => {
  return (
    <HorizontalScrollBar
      scrollKey={currentTab}
      data-testid="tab-group"
      buttonCss={
        activeTabStyle === "underline" ?
          { paddingBottom: spacing.s }
        : undefined
      }
    >
      {tabs.map(tab => (
        <TabItem
          setTab={setTab}
          active={tab.value === currentTab}
          activeTabStyle={activeTabStyle}
          value={tab.value}
          key={tab.value}
          color={color}
        >
          {tab.label}
        </TabItem>
      ))}
    </HorizontalScrollBar>
  );
};
